import React from 'react';
import useStyles from './styles';
import { get } from 'global/lib/lodash';
import clsx from 'clsx';
import { useScreen } from 'global/styles';
import useBodyOverflow from 'global/hooks/useBodyOverflow';
import InDoc from 'global/components/InDoc';

export const InteractiveDocument = (props) => {
  const { doc } = props;
  const classes = useStyles();

  const { isUp } = useScreen();

  useBodyOverflow({ hidden: isUp });

  const isIframe = get(doc, '0.document.assetsDir');

  const getLocalHtmlLink = () => {
    const { dir, html } = isIframe;
    return html;
  };

  return (
    <div className={clsx(classes.container, props.className)}>
      {isIframe && <InDoc url={getLocalHtmlLink()} />}
    </div>
  );
};

export default InteractiveDocument;
